import { goBack, updateAppStatusBar } from './utils/appBridge'
import { markWebviewBoot } from './utils/utils'
import { useSetAppBarTheme } from './hooks/useSetAppBarTheme'
import { useEffect } from 'react'

export const FallBackPage = () => {
  useSetAppBarTheme({ appBarTheme: 'light' })

  useEffect(() => {
    updateAppStatusBar('000000', 'light')
    // The boundary already wrote the failure message. This marks failed only if that write did not happen.
    markWebviewBoot('failed')
  }, [])

  return (
    <div className='h-screen w-full flex flex-col items-center justify-center bg-black text-white px-5 pb-8 relative'>
      <div>
        <svg xmlns='http://www.w3.org/2000/svg' width='64' height='64' viewBox='0 0 64 64' fill='none' className='mb-6'>
          <circle cx='32' cy='32' r='30' stroke='#D3D3D3' strokeWidth='4' fill='none' />
          <line x1='32' y1='18' x2='32' y2='38' stroke='#D3D3D3' strokeWidth='4' strokeLinecap='round' />
          <circle cx='32' cy='46' r='3' fill='#D3D3D3' />
        </svg>
      </div>
      <div className='text-2xl font-[500]'>Something Went Wrong.</div>
      <div className='text-sm mt-2'>Please try again later.</div>
      <div className='mt-auto w-full absolute bottom-8 px-5'>
        <div
          onClick={goBack}
          className='rounded-lg h-[52px] w-full bg-white text-black flex 
          items-center justify-center text-[#232323] font-[500]'
        >
          Go Back
        </div>
      </div>
    </div>
  )
}
